<h2 mat-dialog-title *ngIf="action=='add'">Add Feeder</h2>
<h2 mat-dialog-title *ngIf="action=='update'">Update Feeder</h2>

<mat-tab-group>
    <mat-tab label="Description">
        <div>
            <form [formGroup]="descriptionForm">
                <div class="row col-md-12">
                    <mat-form-field>
                        <mat-label>Feeder Make By</mat-label>
                        <input matInput formControlName="makeBy" required>
                    </mat-form-field>
                    <span class="error"
                    *ngIf="descriptionForm.controls.makeBy.touched && descriptionForm.controls.makeBy.errors?.required">
                        Please Enter Feeder Make By
                    </span>
                </div>

                <div class="row col-md-12">
                    <mat-form-field>
                        <mat-label>Serial Number</mat-label>
                        <input matInput formControlName="serialNo" required>
                    </mat-form-field>
                    <span class="error"
                    *ngIf="descriptionForm.controls.serialNo.errors?.required">
                        Please Enter Serial Number
                    </span>
                </div>

                <div class="row col-md-12">
                    <mat-form-field  >
                        <mat-label>Manufacturing Date</mat-label>
                        <input type="datetime" matInput [matDatepicker]="picker" formControlName="manufacturingDate" >
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>

                    </mat-form-field>
                    <span class=" error"
                    *ngIf=" descriptionForm.controls.manufacturingDate.errors?.required">
                        Please Enter Manufacturing Date
                    </span>
                </div>

                <div class="row col-md-12">
                    <mat-form-field type="datetime"  >
                        <mat-label>Installation Date</mat-label>
                        <input matInput [matDatepicker]="picker1" formControlName="installationDate" >
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>

                    </mat-form-field>
                    <span class=" error"
                    *ngIf="descriptionForm.controls.installationDate.errors?.required">
                        Please Enter Installation Date
                    </span>
                </div>

                <div class="row col-md-12">
                    <mat-form-field  >
                        <mat-label>KVA Rating</mat-label>
                        <input matInput formControlName="rating" required>
                    </mat-form-field>
                    <span class=" error"
                    *ngIf="descriptionForm.controls.rating.touched && descriptionForm.controls.rating.errors?.required">
                        Please Enter KVA Rating
                    </span>
                </div>

                <div class="row col-md-12">
                    <mat-form-field>
                      <mat-label>KV</mat-label>
                      <mat-select formControlName="kv" required>
                        <mat-option *ngFor="let option of kv" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <span class="error"
                      *ngIf="descriptionForm.controls.kv.touched && descriptionForm.controls.kv.errors?.required">
                      Please Enter KV
                    </span>
                </div>
            </form>
        </div>
    </mat-tab>

    <mat-tab *ngIf="roleID == 1" label="Parameter">
        <div>
            <form [formGroup]="parameters">
                <mat-card class="example-card">
                    <mat-card-header>
                        <mat-card-title>
                            <h4>Physical Params</h4>
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="scrollbar scrollbar-primary">
                            <div class="col-md-12" id="test">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Lug Temp</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="lug_temp"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Ambient Temp</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="ambient_temp"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Humidity</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="humidity"></mat-slide-toggle>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

                <mat-card>
                    <mat-card-header>
                        <mat-card-title>
                            <h4>Electrical Parameters</h4>
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="scrollbar scrollbar-primary">
                            <div class="col-md-12" id="test">

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Load %</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="loadPercentage"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>R_Ph_N</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="R_Ph_N"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Y_Ph_N</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Y_Ph_N"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>B_Ph_N</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="B_Ph_N"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>RY_Voltage</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="RY_Voltage"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>YB_Voltage</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="YB_Voltage"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>BR_Voltage</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="BR_Voltage"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>L1</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="L1"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>L2</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="L2"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>L3</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="L3"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>LN</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="LN"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>I1</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="I1"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>I2</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="I2"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>I3</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="I3"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>R1</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="R1"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>R2</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="R2"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>R3</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="R3"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>R Power Factor</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="R_Power_Factor"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Y Power Factor</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Y_Power_Factor"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>B Power Factor</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="B_Power_Factor"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Avg Power Factor</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Avg_Power_Factor"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>R Active Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="R_Active_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Y Active Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Y_Active_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>B Active Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="B_Active_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Phase Active Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Phase_Active_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>R Reactive Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="R_Reactive_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Y Reactive Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Y_Reactive_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>B Reactive Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="B_Reactive_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Phase Reactive Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Phase_Reactive_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>R Apparent Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="R_Apparent_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Y Apparent Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Y_Apparent_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>B Apparent Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="B_Apparent_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Phase Apparent Power</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Phase_Apparent_Power"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Frequency</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Frequency"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Device Temperature</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="Device_Temp"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>VR THD</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="VR_THD"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>VY THD</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="VY_THD"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>VB THD</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="VB_THD"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>IR THD</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="IR_THD"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>IY THD</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="IY_THD"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>IB THD</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="IB_THD"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>RP THD</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="RP_THD"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>YP THD</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="YP_THD"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>BP THD</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="BP_THD"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>System kWh</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="System_Kwh"></mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label>System kvAh</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="System_KvAh"></mat-slide-toggle>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </form>
        </div>
    </mat-tab>

    <mat-tab label="Alert Parameters">
        <form [formGroup]="alertParameter">
            <h4>Alert Parameters</h4>
            <div class="row">
                <table>

                    <tr>
                        <td>
                            <mat-form-field class="form-element" style="margin-left: 15%;">
                                <mat-label>Frequency</mat-label>
                                <input type="number" matInput (keyup)= "checkFrequency($event,'overLoadFrequency','apOverLoadTime')" formControlName = "overLoadFrequency" >
                            </mat-form-field>
                            <span class="error"
                                *ngIf="frequencyMsg && frequencyMsg.apOverloadFrequency && frequencyMsg.apOverloadFrequency.length > 0">
                                {{frequencyMsg.apOverloadFrequency}}
                            </span>
                        </td>
                        <td>
                            <mat-label>Minutes</mat-label>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <mat-form-field style="margin-left: 15%;" >
                                <mat-label>Over Load(Amp) </mat-label>
                                <input type="number" matInput formControlName="overLoad">
                            </mat-form-field>
                            <span class=" error"
                            *ngIf="alertParameter.controls.overLoad.touched && alertParameter.controls.overLoad.errors?.required">
                                Please Enter Overload
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName = "overLoadEmail" ></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName = "overLoadSMS"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select   formControlName="overLoadTime" >
                                    <mat-option  *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>
                            <mat-form-field style="margin-left: 15%;" >
                                <mat-label>Under Load(Amp) </mat-label>
                                <input type="number" matInput formControlName="underLoad">
                            </mat-form-field>
                            <span class=" error"
                            *ngIf="alertParameter.controls.underLoad.touched && alertParameter.controls.underLoad.errors?.required">
                                Please Enter Under Load
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName = "underLoadEmail" ></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName = "underLoadSMS"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select   formControlName="underLoadTime" >
                                    <mat-option  *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>
                            <mat-form-field style="margin-left: 15%;" >
                                <mat-label>Critical Load(Amp) </mat-label>
                                <input type="number" matInput formControlName="criticalLoad">
                            </mat-form-field>
                            <span class=" error"
                            *ngIf="alertParameter.controls.criticalLoad.touched && alertParameter.controls.criticalLoad.errors?.required">
                                Please Enter Critical Load
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName = "criticalLoadEmail" ></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName = "criticalLoadSMS"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select   formControlName="criticalLoadTime" >
                                    <mat-option  *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>
                            <mat-form-field style="margin-left: 15%;" >
                                <mat-label>High Voltage </mat-label>
                                <input type="number" matInput formControlName="highVoltage">
                            </mat-form-field>
                            <span class=" error"
                            *ngIf="alertParameter.controls.highVoltage.touched && alertParameter.controls.highVoltage.errors?.required">
                                Please Enter High Voltage
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName = "highVoltageEmail" ></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName = "highVoltageSMS"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-form-field class="form-element" hidden=false>
                                <mat-label>Time</mat-label>
                                <mat-select   formControlName="highVoltageTime" >
                                    <mat-option  *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>
                            <mat-form-field style="margin-left: 15%;" >
                                <mat-label>Low Voltage </mat-label>
                                <input type="number" matInput formControlName="lowVoltage">
                            </mat-form-field>
                            <span class=" error"
                            *ngIf="alertParameter.controls.lowVoltage.touched && alertParameter.controls.lowVoltage.errors?.required">
                                Please Enter High Voltage
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName = "lowVoltageEmail" ></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName = "lowVoltageSMS"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-form-field class="form-element" hidden=false>
                                <mat-label>Time</mat-label>
                                <mat-select   formControlName="lowVoltageTime" >
                                    <mat-option  *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>
                            <mat-form-field style="margin-left: 15%;" >
                                <mat-label>V Unbalance </mat-label>
                                <input type="number" matInput formControlName="vUnbalance">
                            </mat-form-field>
                            <span class=" error"
                            *ngIf="alertParameter.controls.vUnbalance.touched && alertParameter.controls.vUnbalance.errors?.required">
                                Please Enter High Voltage
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName = "vUnbalanceEmail" ></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName = "vUnbalanceSMS"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-form-field class="form-element" hidden=false>
                                <mat-label>Time</mat-label>
                                <mat-select   formControlName="vUnbalanceTime" >
                                    <mat-option  *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>
                            <mat-form-field style="margin-left: 15%;" >
                                <mat-label>I Unbalance </mat-label>
                                <input type="number" matInput formControlName="iUnbalance">
                            </mat-form-field>
                            <span class=" error"
                            *ngIf="alertParameter.controls.iUnbalance.touched && alertParameter.controls.iUnbalance.errors?.required">
                                Please Enter High Voltage
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName = "iUnbalanceEmail" ></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName = "iUnbalanceSMS"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-form-field class="form-element" hidden=false>
                                <mat-label>Time</mat-label>
                                <mat-select   formControlName="iUnbalanceTime" >
                                    <mat-option  *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>
                            <mat-form-field style="margin-left: 15%;" >
                                <mat-label> Lug Temp</mat-label>
                                <input type="number" matInput formControlName="lugTemp">
                            </mat-form-field>
                            <span class=" error"
                            *ngIf="alertParameter.controls.lugTemp.touched && alertParameter.controls.lugTemp.errors?.required">
                                Please Enter High Voltage
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName = "lugTempEmail" ></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName = "lugTempSMS"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-form-field class="form-element" hidden=false>
                                <mat-label>Time</mat-label>
                                <mat-select   formControlName="lugTempTime" >
                                    <mat-option  *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </tr>
                </table>
            </div>
        </form>
    </mat-tab>

    <mat-tab label="Alert Notification">
        <form [formGroup]="altertNotification"  class="form">
            <h4>Email for Alarms</h4>
            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Email 1</mat-label>
                    <input matInput formControlName="email1" required>
                </mat-form-field>
                <span class=" error"
                    *ngIf="altertNotification.controls.email1.touched && altertNotification.controls.email1.errors?.required">
                    Please Enter Email 1
                </span>
                <span class="error"
                    *ngIf="altertNotification.controls.email1.touched && altertNotification.controls.email1.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>
            <div class="row col-md-12">

                <mat-form-field  >
                    <mat-label>Email 2</mat-label>
                    <input matInput formControlName="email2">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email2.touched && altertNotification.controls.email2.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>
            <div class="row col-md-12">

                <mat-form-field  >
                    <mat-label>Email 3</mat-label>
                    <input matInput formControlName="email3">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email3.touched && altertNotification.controls.email3.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>
            <div class="row col-md-12">

                <mat-form-field  >
                    <mat-label>Email 4</mat-label>
                    <input matInput formControlName="email4">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email4.touched && altertNotification.controls.email4.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>
            <div class="row col-md-12">

                <mat-form-field  >
                    <mat-label>Email 5</mat-label>
                    <input matInput formControlName="email5">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email5.touched && altertNotification.controls.email5.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>

            <h4>SMS For Alarms</h4>

            <div class="row col-md-12">

                <mat-form-field>
                    <mat-label>Phone Number 1</mat-label>
                    <input matInput formControlName="phoneNo1" required>
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo1.touched && altertNotification.controls.phoneNo1.errors?.required">
                    Please Enter Phone Number 1
                </span>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo1.touched && altertNotification.controls.phoneNo1.errors?.pattern">
                    Please Enter Valid Phone Number 1
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 2</mat-label>
                    <input matInput formControlName="phoneNo2">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo2.touched && altertNotification.controls.phoneNo2.errors?.pattern">
                    Please Enter Valid Phone Number 2
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 3</mat-label>
                    <input matInput formControlName="phoneNo3">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo3.touched && altertNotification.controls.phoneNo3.errors?.pattern">
                    Please Enter Valid Phone Number 3
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 4</mat-label>
                    <input matInput formControlName="phoneNo4">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo4.touched && altertNotification.controls.phoneNo4.errors?.pattern">
                    Please Enter Valid Phone Number 4
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 5</mat-label>
                    <input matInput formControlName="phoneNo5">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo5.touched && altertNotification.controls.phoneNo5.errors?.pattern">
                    Please Enter Valid Phone Number 5
                </span>
            </div>

        </form>
    </mat-tab>

    <mat-tab *ngIf="roleID == 1" label="DTMU Device">
        <form [formGroup]="dtmuDevice" *ngIf="dtmuDevice" class="form">
            <h4>New Machine Details</h4>
            <div class="row col-md-12">
                <mat-form-field >
                    <mat-label>Device Category</mat-label>
                    <mat-select formControlName="deviceCategory" required>
                        <mat-option  *ngFor="let category of deviceMaster.deviceCategory" [value]="category">
                             {{category}}
                        </mat-option>
                    </mat-select>
                 </mat-form-field>
                 <span class="error"
                 *ngIf="dtmuDevice.controls.deviceCategory.touched && dtmuDevice.controls.deviceCategory.errors?.required">
                Please Select Device Category
             </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Device Model</mat-label>
                    <mat-select  formControlName="deviceModel" required>
                        <mat-option *ngFor='let model of deviceMaster.deviceModel' [value]="model">
                            {{model}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>
            </div>

            <div class="row col-md-12">
                <mat-form-field >
                    <mat-label>Device ID</mat-label>
                    <mat-select formControlName="deviceId" required>
                        <mat-option *ngFor='let deviceId of deviceMaster.deviceId' [value]="deviceId">
                            {{deviceId}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>

            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Heart Beat</mat-label>
                    <input matInput formControlName="heartBeat" required>
                </mat-form-field>
                <span class="error"
                    *ngIf="dtmuDevice.controls.heartBeat.touched && dtmuDevice.controls.heartBeat.errors?.required">
                    Please Enter Heart Beat
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" required>
                </mat-form-field>
                <span class="error"
                    *ngIf="dtmuDevice.controls.name.touched && dtmuDevice.controls.name.errors?.required">
                    Please Enter Name
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Passcode</mat-label>
                    <input matInput formControlName="passcode" required>
                </mat-form-field>
            </div>
       
            <div class="row col-md-12">
                <mat-label>Remote Controller</mat-label>
                <mat-slide-toggle formControlName = "remoteController"></mat-slide-toggle>
            </div>

            <div class="row col-md-12">
                <mat-label>ON OFF Notify</mat-label>
                <mat-slide-toggle formControlName = "onOffNotify"></mat-slide-toggle>
            </div>

            <div class="row col-md-12">
                <mat-label>ON OFF Flag</mat-label>
                <mat-slide-toggle formControlName = "onOffFlag"></mat-slide-toggle>
            </div>

        </form>
    </mat-tab>
</mat-tab-group>

<mat-dialog-actions>
    <div class="form-element">
        <button mat-raised-button color="primary" type="submit" [disabled]="!descriptionForm.valid || !altertNotification.valid || !dtmuDevice.valid" (click)="onSubmit(descriptionForm.value, parameters.value, alertParameter.value, altertNotification.value, dtmuDevice.value)" class="button" >Save</button>
    </div>
    <button class="mat-raised-button" (click)="close('NA')">Close</button>
</mat-dialog-actions>